import * as Blockly from 'blockly/core'

const blockStyles = {
  control: {
    colourPrimary: '#ec7a1b',
  },
  events: {
    colourPrimary: '#f3a423',
  },
  looks: {
    colourPrimary: '#7440e9',
  },
  movement: {
    colourPrimary: '#4e85fb',
  },
  operators: {
    colourPrimary: '#4daa42',
  },
  procedures: {
    colourPrimary: '#FD4B6B',
  },
  sensing: {
    colourPrimary: '#3e9fd7',
  },
  sound: {
    colourPrimary: '#c454cd',
  },
  variables: {
    colourPrimary: '#ea6018',
  },
}

const categoryStyles = Object.fromEntries(
  Object.entries(blockStyles).map(([k, v]) => [
    k,
    {
      colour: v.colourPrimary,
    },
  ]),
)

const theme = Blockly.Theme.defineTheme('robcratch', {
  base: Blockly.Themes.Classic,
  name: 'robcratch',
  startHats: true,
  blockStyles,
  categoryStyles,
})

export default theme
